<script lang="ts">
    import { location, currentPageType, generalInfo, showMobileNav, currentColorTheme } from "../../store"

    import LanguageChooser from "./LanguageChooser.svelte"
    import Navigation from "./Navigation.svelte"

    export let type: number = 0

    let y: number
    let lastScrollY: number = 0
    let innerHeight: number = 0
    let outerHeight: number = 0
    let show: boolean = true

    $: isRedBrand = () => {
        if ($currentColorTheme === "dark") {
            return false
        } else {
            if ($location.path === "/" && y < innerHeight) {
                return false
            }
        }

        return true
    }

    const hideAfterTimeout = (ms: number = 3000): void => {
        window.setTimeout(() => {
            show = false
        }, ms)
    }

    const scrollDirection = () => {
        const d = lastScrollY <= y ? "down" : "up"

        if ($location.path !== "/") {
            if (d === "up") {
                show = true
            } else if (d === "down") {
                show = false
            }
        }

        lastScrollY = y <= 0 ? 0 : y
    }

    // Home
    if (type === 0) {
        hideAfterTimeout()
    }

    $: if (y && type === 1) scrollDirection()
</script>

<svelte:window bind:scrollY="{y}" bind:innerHeight bind:outerHeight />

<header>
    <div
        class="header-content type-{type} {y > innerHeight ? 'bg-' + $currentColorTheme : ''}"
        class:show="{$location.path == '/' ? true : show}"
    >
        <div class="wm-container">
            <a href="/" class="brand" class:red="{isRedBrand()}">
                <img src="/img/brand/logo-weiss.png" alt="{$generalInfo?.company.companyName}" class="brand-white" />
                <img src="/img/brand/logo.png" alt="{$generalInfo?.company.companyName}" class="brand-red" />
            </a>

            <div
                class="nav-mobile-toggle"
                class:white="{$currentColorTheme === 'dark' ||
                    (y < innerHeight && !['default', 'projects', 'project'].includes($currentPageType))}"
                on:click="{() => {
                    $showMobileNav = !$showMobileNav
                }}"
                on:keydown
            >
                <img
                    src="/img/icons/healthicons_ui-menu{$currentColorTheme === 'dark' ||
                    (y < innerHeight && !['default', 'projects', 'project'].includes($currentPageType))
                        ? '-white'
                        : ''}.svg"
                    alt=""
                />
            </div>
        </div>
    </div>
</header>

<div class="main-mobile" class:show="{$showMobileNav}">
    <div class="wm-container main-mobile-header type-{type}">
        <div class="wm-row">
            <div class="wm-col-md-12">
                <a href="/" class="brand">
                    <img
                        src="/img/brand/logo{$currentColorTheme === 'dark' ? '-weiss' : ''}.png"
                        alt="{$generalInfo?.company.companyName}"
                    />
                </a>

                <div class="nav-mobile-toggle" on:click="{() => ($showMobileNav = !$showMobileNav)}" on:keydown>
                    <img src="/img/icons/bytesize_close{$currentColorTheme === 'dark' ? '-white' : ''}.svg" alt="" />
                </div>
            </div>
        </div>
    </div>
    <div class="wm-container nav-mobile-content">
        <div class="wm-row content-row">
            <div class="wm-col-md-12">
                <Navigation ident="main" />
            </div>
        </div>
        <div class="wm-row nav-mobile-navigation-row">
            <div class="wm-col-md-12">
                <Navigation ident="footer" />
                <LanguageChooser />
            </div>
        </div>
    </div>
</div>
